// import { SET_MESSAGE, CLEAR_MESSAGE } from "./types";
// import RestService from "../services/rest.service";
// export const setMessage = (message) => ({
//   type: SET_MESSAGE,
//   payload: message,
// });
//
// export const clearMessage = () => ({
//   type: CLEAR_MESSAGE,
// });
import workloadAndPerformanceService from "../services/workloadAndPerformance.service";

export const getPortfolioDetailSummary = (rb_pa_id) => (dispatch) => {
  // mapping data
  return  workloadAndPerformanceService.getSummary(rb_pa_id).then(
        (response) => {
          dispatch({
            type: "SET_PORTFOLIO_DETAIL",
            payload: response ,
          });
          return Promise.resolve(response);
        }
      );
};


export const getPortfolioList = () => (dispatch) => {
  return  workloadAndPerformanceService.getYear().then(
    (response) => {
      dispatch({
        type: "SET_PORTFOLIO_LIST",
        payload: response ,
      });
      return Promise.resolve(response);
    }
  );
};

export const getPortfolioDetail = () => (dispatch) => {
  const mockData = require("../../src/data/portfolio_mockup.json");
  const oData = mockData.workloadDetailSummary;
  // mapping data
  return new Promise((resolve) => {
    dispatch({
      type: "SET_PORTFOLIO_DETAIL",
      payload: oData,
    });
    resolve(oData);
  });
};


export const getPortfolioWorkloadTypeList = () => (dispatch) => {
  // mapping data
  return  workloadAndPerformanceService.getType().then(
    (response) => {
      dispatch({
        type: "SET_PORTFOLIO_WORKLOAD_TYPE_LIST",
        payload: response ,
      });
      return Promise.resolve(response);
    }
  );
};

export const getPortfolioDetailList = (rb_pa_id) => (dispatch) => {
  return  workloadAndPerformanceService.getList(rb_pa_id).then(
    (response) => {
      dispatch({
        type: "SET_PORTFOLIO_WORKLOAD_DETAIL_LIST",
        payload: response ,
      });
      return Promise.resolve(response);
    }
  );
};

// export const deletePortfolioDetailList = () => (dispatch) => {
//   return  workloadAndPerformanceService.getType().then(
//     (response) => {
//       dispatch({
//         type: "SET_PORTFOLIO_WORKLOAD_DETAIL_LIST",
//         payload: response ,
//       });
//       return Promise.resolve(response);
//     }
//   );
// };

// export const getPortfolioWorkloadFiles = () => (dispatch) => {
//   return  workloadAndPerformanceService.getFile().then(
//     (response) => {
//       dispatch({
//         type: "SET_PORTFOLIO_WORKLOAD_DETAIL_LIST",
//         payload: response ,
//       });
//       return Promise.resolve(response);
//     }
//   );
// };
